/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_speed_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiply km/h by 0.6214, or roughly divide by 1.6. For a fast mental estimate, multiply by 0.6 — 100 km/h is close to 62 mph (the precise answer is 62.14 mph). For anything safety-related, like reading a foreign speed limit, use the exact conversion, not the shortcut.`)
};

const es_uc_speed_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplica km/h por 0.6214, o aproximadamente divide por 1.6. Para una estimación mental rápida, multiplica por 0.6 — 100 km/h es cercano a 62 mph (la respuesta precisa es 62.14 mph). Para cualquier cosa relacionada con seguridad, como leer un límite de velocidad extranjero, usa la conversión exacta, no el atajo.`)
};

const de_uc_speed_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplizieren Sie km/h mit 0.6214, oder teilen Sie grob durch 1.6. Für eine schnelle Kopfschätzung multiplizieren Sie mit 0.6 — 100 km/h sind nahe an 62 mph (die genaue Antwort ist 62.14 mph). Für alles Sicherheitsrelevante, etwa das Ablesen eines ausländischen Tempolimits, verwenden Sie die exakte Umrechnung, nicht die Faustregel.`)
};

const nl_uc_speed_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vermenigvuldig km/u met 0.6214, of ruwweg gedeeld door 1.6. Voor een snelle mentale schatting, vermenigvuldig met 0.6 — 100 km/u is dicht bij 62 mph (het precieze antwoord is 62.14 mph). Voor alles veiligheid gerelateerd, zoals het lezen van een buitenlands snelheidslimiet, gebruik de exacte conversie, niet de snelkoppeling.`)
};

const fr_uc_speed_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multipliez km/h par 0,6214, ou divisez grossièrement par 1,6. Pour une estimation mentale rapide, multipliez par 0,6 — 100 km/h est proche de 62 mph (la réponse précise est 62,14 mph). Pour n'importe quoi lié à la sécurité, comme lire une limite de vitesse étrangère, utilisez la conversion exacte, pas le raccourci.`)
};

const it_uc_speed_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moltiplica km/h per 0,6214, o approssimativamente dividi per 1,6. Per una stima mentale veloce, moltiplica per 0,6 — 100 km/h è vicino a 62 mph (la risposta precisa è 62,14 mph). Per qualsiasi cosa relativa alla sicurezza, come leggere un limite di velocità straniero, usa la conversione esatta, non la scorciatoia.`)
};

const pt_br2_uc_speed_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplique km/h por 0.6214, ou aproximadamente divida por 1.6. Para uma estimativa mental rápida, multiplique por 0.6 — 100 km/h é próximo a 62 mph (a resposta precisa é 62.14 mph). Para qualquer coisa relacionada a segurança, como ler um limite de velocidade estrangeiro, use a conversão exata, não o atalho.`)
};

const pt_uc_speed_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplicar km/h por 0,6214, ou aproximadamente dividir por 1,6. Para uma estimativa mental rápida, multiplicar por 0,6 — 100 km/h é perto de 62 mph (a resposta precisa é 62,14 mph). Para qualquer coisa relacionada com segurança, como ler um limite de velocidade estrangeira, utilize a conversão exacta, não o atalho.`)
};

const ja_uc_speed_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`km/h に0.6214を乗じるか、大体1.6で除きます。高速の精神的見積もりのため、0.6で乗じます — 100 km/h は62 mph に近い(正確な答えは62.14 mph です)。速度制限を読むなど、安全関連のため、ショートカットではなく正確な変換を使用します。`)
};

const zh_uc_speed_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_speed_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_speed_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_speed_faq1_a", locale)
	if (locale === "en") return en_uc_speed_faq1_a(inputs)
	if (locale === "es") return es_uc_speed_faq1_a(inputs)
	if (locale === "de") return de_uc_speed_faq1_a(inputs)
	if (locale === "nl") return nl_uc_speed_faq1_a(inputs)
	if (locale === "fr") return fr_uc_speed_faq1_a(inputs)
	if (locale === "it") return it_uc_speed_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_speed_faq1_a(inputs)
	if (locale === "pt") return pt_uc_speed_faq1_a(inputs)
	if (locale === "ja") return ja_uc_speed_faq1_a(inputs)
	return zh_uc_speed_faq1_a(inputs)
};